import h from 'hyperscript';

import type { EventKey } from '@disy/lib/event-util';
import { on, unByKey } from '@disy/lib/event-util';
import { createButton } from '@disy/ui/button';

import { bindHotkey, getFormattedHotkey, unbindHotkey } from 'cadenza/hotkeys/hotkeys';
import { isWorksheetOnDemandOverlayVisible } from 'cadenza/map/on-demand/on-demand-map.state';
import { getStore } from 'cadenza/store/cadenza-store';

import './on-demand-overlay.css';
import i18n from './on-demand-overlay.properties';

const COMPONENT_NAME = 'd-on-demand-overlay';

export class OnDemandOverlay extends HTMLElement {
  #eventKeys?: EventKey[];

  connectedCallback() {
    this.hidden = !isWorksheetOnDemandOverlayVisible(getStore().getState());
    this.classList.add(COMPONENT_NAME, 'd-on-demand-overlay--cover');
    const loadDataButton = createButton(i18n('onDemand.load-data'), {
      variant: 'primary',
    });

    this.#eventKeys = [
      on(loadDataButton, 'click', () => {
        this.#load();
      }),
    ];

    this.append(
      h('span.headline', i18n('onDemand.title')),
      loadDataButton,
      h('span.keyboard-hint.text-muted', `(${getFormattedHotkey('WORKBOOK_UPDATE_ON_DEMAND_VIEW')})`),
    );

    bindHotkey({
      hotkeyId: 'WORKBOOK_UPDATE_ON_DEMAND_VIEW',
      callback: () => {
        // TODO (simon, 11.07.2023, several places use hotkey callbacks with event in this fashion. This is not
        //  a clean way of handling this. The callback should come with the event)
        event?.preventDefault();
        if (!this.hidden) {
          this.#load();
        }
      },
    });
  }

  disconnectedCallback() {
    unByKey(this.#eventKeys);
    unbindHotkey('WORKBOOK_UPDATE_ON_DEMAND_VIEW');
  }

  #load() {
    this.hidden = true;
    this.dispatchEvent(new CustomEvent('ondemand:load'));
  }
}

customElements.define(COMPONENT_NAME, OnDemandOverlay);
